export default "__VITE_ASSET__DtPXA3KC__"